<section>
    <h2>Advertisment</h2>
    <app-advertisment [userInfos]="userInfos" [advertismentData]="dataSource" [platformInfos]="platformInfos"></app-advertisment>
</section>